module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plan-update"
  }, [_c('form', {
    staticClass: "plan-update--form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('h1', [_vm._v("\n      " + _vm._s(this.item.name) + "\n    ")]), _vm._v(" "), _c('field', {
    attrs: {
      "errors": _vm.errors,
      "required": true,
      "model": "plan",
      "name": "name",
      "placeholder": "STARTER"
    },
    model: {
      value: (_vm.item.name),
      callback: function($$v) {
        _vm.$set(_vm.item, "name", $$v)
      },
      expression: "item.name"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "errors": _vm.errors,
      "required": true,
      "model": "plan",
      "name": "price",
      "placeholder": "249.99"
    },
    model: {
      value: (_vm.item.price),
      callback: function($$v) {
        _vm.$set(_vm.item, "price", $$v)
      },
      expression: "item.price"
    }
  }), _vm._v(" "), _c('accordion', {
    attrs: {
      "defaultActive": false,
      "title": "ui.pages.plan-rules"
    }
  }, [_c(_vm.accordionOne, _vm._b({
    tag: "component"
  }, 'component', _vm.accordionOneProps, false))], 1), _vm._v(" "), _c('accordion', {
    attrs: {
      "title": "ui.pages.plan-organizations"
    }
  }, [_c(_vm.accordionTwo, _vm._b({
    tag: "component"
  }, 'component', _vm.accordionTwoProps, false))], 1), _vm._v(" "), _c('page-saver', {
    on: {
      "save": _vm.update,
      "cancel": _vm.cancel
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47ababc6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/plans/PlanUpdate.vue
// module id = 1891
// module chunks = 0